import { render, staticRenderFns } from "./BatchNameModal.vue?vue&type=template&id=b90e513c&scoped=true&"
import script from "./BatchNameModal.vue?vue&type=script&lang=js&"
export * from "./BatchNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b90e513c",
  null
  
)

export default component.exports